import React from "react"
import { Swiper, SwiperSlide } from "swiper/react"
import { Container, Row, Col } from "react-bootstrap"
import "swiper/css"
import { Autoplay } from "swiper/modules"

const CharitiesSwiper = ({ data, title, renderSlide }) => {
  const { logos } = data

  const sliderSettings = {
    className: "home-partner-slider-swiper home-partner-slider",
    loop: false,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
    slidesPerView: 6,
    pagination: { clickable: true },
    modules: [Autoplay],
    breakpoints: {
      1024: { slidesPerView: 5, spaceBetween: 20 },
      768: { slidesPerView: 3, spaceBetween: 15 },
      320: { slidesPerView: 2, spaceBetween: 10 },
    },
  }

  return (
    <div className="home-partner-logo charities-logo-wrap mb-0">
      <Container fluid>
        <Row>
          <Col md={2} className="black-bg">
            <div className="text-size-18" style={{ fontWeight: 500 }}>
              {title || "Charities"}
            </div>
          </Col>
          <Col md={10}>
            <Swiper {...sliderSettings}>
              {logos?.map((logoItem, index) => (
                <SwiperSlide key={index}>
                  {renderSlide ? renderSlide(logoItem) : null}
                </SwiperSlide>
              ))}
            </Swiper>
          </Col>
        </Row>
      </Container>
    </div>
  )
}

export default CharitiesSwiper
